var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Box, Divider, Drawer } from "@mui/material";
import { display, drawerfordesktop, maincomponent, boxdrawer } from "../../css/NavigationObjectCss";
import { DrawerContext } from "../model/model";
import Navigation from "./Navigation";
import "../../css/Navigation.css";
import Navbar from "./Navbar";
import Tabs from "./Tabs";
import { useDeviceQueries } from "../../shared/Utilites";
export default function HomeLayout() {
    var _a = useState(false), mobileOpen = _a[0], setMobileOpen = _a[1];
    var _b = useState(Tabs()[0]), activeTab = _b[0], setActiveTab = _b[1];
    var handleDrawerToggle = function () {
        setMobileOpen(!mobileOpen);
    };
    var isMobile = useDeviceQueries();
    // Prevent body scroll when mobile drawer is open
    useEffect(function () {
        if (isMobile && mobileOpen) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "auto";
        }
        // Cleanup on unmount
        return function () {
            document.body.style.overflow = "auto";
        };
    }, [isMobile, mobileOpen]);
    var drawer = (_jsxs(_Fragment, { children: [_jsx(Navigation, { setActiveTab: setActiveTab, setMobileOpen: setMobileOpen }), _jsx(Divider, {})] }));
    return (_jsx(_Fragment, { children: _jsxs(DrawerContext.Provider, __assign({ value: { mobileOpen: mobileOpen, handleDrawerToggle: handleDrawerToggle, setMobileOpen: setMobileOpen } }, { children: [_jsx(Navbar, {}), _jsxs(Box, __assign({ sx: { paddingTop: { xs: "20px !important", sm: "65px !important" } } }, { children: [isMobile && mobileOpen && (_jsx(Box, __assign({ className: "ST_mobile_backdrop", onClick: handleDrawerToggle }, { children: _jsx(Box, __assign({ className: "ST_mobile_drawer ST_navigation_drawer ".concat(mobileOpen ? "open" : "closed") }, { children: _jsx(Box, __assign({ sx: { paddingTop: "65px" } }, { children: drawer })) })) }))), _jsxs(Box, __assign({ sx: display }, { children: [_jsx(Box, __assign({ component: "nav", sx: boxdrawer, "aria-label": "mailbox folders" }, { children: !isMobile && (_jsx(Drawer, __assign({ variant: "permanent", open: true, sx: drawerfordesktop, className: "ST_navigation_drawer" }, { children: drawer }))) })), _jsx(Box, __assign({ component: "main", sx: maincomponent, style: { marginTop: "0.1px" } }, { children: _jsx("div", __assign({ role: "tabpanel", hidden: false, id: "vertical-tabpanel-".concat(activeTab.index), "aria-labelledby": "vertical-tab-".concat(activeTab.index) }, { children: _jsx(Box, { children: activeTab.component }) })) }))] }))] }))] })) }));
}
